<div class="agent-dashboard">


    <div class="row">
        <div class=" col-md-9 col-sm-6">
            <div class="tabs">
                <ul>
                    <li (click)="getRmProspects();" [ngClass]="{'active': isProspectHighLight}">Prospect</li>
                    <li (click)="getRmClients();" [ngClass]="{'active': isClientHighLight}">Client</li>
                    <li (click)="getRmRenewals();" [ngClass]="{'active': isRenewalsHighLight}">Renewals</li>
            
                </ul>
            </div>

        </div>
        <div class=" col-md-3 col-sm-6">


            <div class="search-mob">        
                <span>
                    <input
                    type="text"
                    placeholder="Search by Mobile"
                    class="form-control searchFieldMob"
                    [(ngModel)]="mobileValue" (ngModelChange)="SearchMobile()"
                    />
                </span>  
                <span>
                    <input
                    type="text"
                    [placeholder]="placeholderValue"
                    class="form-control searchFieldMob"
                    [(ngModel)]="ProspectName" (ngModelChange)="SearchProspectName()"
                   />
                </span>  
            </div>


        </div>
       
      </div>



   
    <div class="list table-responsive">
        <ng-container *ngIf="isProspect">
            <table >
                <thead>
                    <tr>
                        <th class="col-1">SL.</th>
                        <!-- <th class="col-2">Prospect Name</th>
                        <th class="col-3">Product Name</th> -->
                        <th class="col-2" (click)="sort('clientName')">Prospect Name<i class="fa fa-sort"></i></th>
                        <th class="col-3" (click)="sort('productName')">Product Name<i class="fa fa-sort"></i></th>
                        <th class="col-3">Mobile</th>
                        <th class="col-2">Status</th>
                        <th class="col-1">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lead of leadList | orderBy :key :reverse | paginate: { itemsPerPage: 5,
                         currentPage: page, 
                        totalItems:totalLength},index as i;">
                        
                        <td class="col-1">{{(i+1)+(page-1)*5}}</td>
                        <td class="col-2">{{lead.clientName}}</td>
                        <td class="col-3">{{lead.productName}}</td>
                        <td class="col-3">{{lead.mobile}}</td>
                        <td class="col-2">{{lead.status}}</td>
                        <td class="col-1"><button type="button" class="btn  btn-sm" id="comment-button" (click)="addComment(lead);">Add Comment</button></td>
                    </tr>
                    <tr *ngIf="!isProspectLength">
                        <td class="error text-center" colspan="5"><small>Lead Data Empty</small></td>
                    </tr> 
                    <tr *ngIf="searchMobileLead">
                        <td class="error text-center" colspan="5"><small>No prospect found by this mobile number.</small></td>
                    </tr> 
                    <tr *ngIf="SearchProspectLead">
                        <td class="error text-center" colspan="5"><small>No prospect found by this name.</small></td>
                    </tr> 
                </tbody>
            </table>
            <div class="pages">
            <pagination-controls  maxSize="5" class="my-pagination" (pageChange)="page = $event"></pagination-controls>
         </div>
        </ng-container>   

        <ng-container  *ngIf="isClient">
            <table>
                <thead>
                    <tr>
                        <th class="col-1">SL.</th>
                        <!-- <th class="col-3" >Client Name</th>
                        <th class="col-4" >Product Name</th> -->
                        <th class="col-3" (click)="sort('clientName')">Client Name<i class="fa fa-sort"></i></th>
                        <th class="col-4" (click)="sort('productName')">Product Name<i class="fa fa-sort"></i></th>
                        <th class="col-3">Mobile</th>
                        <!-- <th class="col-1" style="white-space: nowrap;">Last Edit</th> -->
                        <th class="col-1" style="white-space: nowrap;" (click)="sort('lastUpdated')">Last Edit<i class="fa fa-sort"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let client of clientList | orderBy :key :reverse | paginate: { itemsPerPage: 5,
                        currentPage: page, 
                       totalItems:totalLength },index as j;">
                       
                        <td class="col-1">{{(j+1)+(page-1)*5}}</td>
                        <td class="col-3">{{client.clientName}}</td>
                        <td class="col-4">{{client.productName}}</td>
                        <td class="col-3">{{client.mobile}}</td>
                        <td class="col-1" style="white-space: nowrap;">{{client.lastUpdated.split(" ")[0]}}</td>
                    </tr>
                    <tr *ngIf="!isClientLength">
                        <td class="error text-center" colspan="5"><small>Client Data Empty</small></td>
                    </tr>
                    <tr *ngIf="searchMobileLead">
                        <td class="error text-center" colspan="5"><small>No client found by this mobile number.</small></td>
                    </tr> 
                    <tr *ngIf="SearchProspectLead">
                        <td class="error text-center" colspan="5"><small>No client found by this name.</small></td>
                    </tr> 
                </tbody>
            </table>
            <div class="pages">
                <pagination-controls maxSize="5" class="my-pagination" (pageChange)="page = $event"></pagination-controls>
             </div>
        </ng-container>   

        <ng-container  *ngIf="isRenewals" >
            <table>
                <thead>
                    <tr>
                        <th class="col-1">SL.</th>
                        <!-- <th class="col-2">Client Name</th>
                        <th class="col-3">Product Name</th> -->
                        <th class="col-2" (click)="sort('clientName')">Client Name<i class="fa fa-sort"></i></th>
                        <th class="col-3" (click)="sort('productName')">Product Name<i class="fa fa-sort"></i></th>
                        <th class="col-3">Mobile</th>
                        <th class="col-2" (click)="sort('renewalDate')">Renewal Date<i class="fa fa-sort"></i></th>
                        <!-- <th class="col-2">Renewal Date</th> -->
                        <th class="col-1">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let renewal of renewalList | orderBy :key :reverse | paginate: { itemsPerPage: 5,
                        currentPage: page, 
                       totalItems:totalLength} ,index as k;">
                        <td class="col-1">{{(k+1)+(page-1)*5}}</td>
                        <td class="col-2">{{renewal.clientName}}</td>
                        <td class="col-3">{{renewal.productName}}</td>
                        <td class="col-3">{{renewal.mobile}}</td>
                        <td class="col-2">{{renewal.renewalDate.split(" ")[0]}}</td>
                        <td class="col-1"><button type="button" class="btn  btn-sm" id="comment-button" (click)="addComment(renewal);">Add Comment</button></td>
                    </tr>
                    <tr *ngIf="!isRenewalsLength">
                        <td class="error text-center" colspan="5"><small>Renewal Data Empty</small></td>
                    </tr>
                    <tr *ngIf="searchMobileLead">
                        <td class="error text-center" colspan="5"><small>No renewal found by this mobile number.</small></td>
                    </tr> 
                    <tr *ngIf="SearchProspectLead">
                        <td class="error text-center" colspan="5"><small>No renewal found by this name.</small></td>
                    </tr> 
                </tbody>
            </table>
            <div class="pages">
                <pagination-controls maxSize="5" class="my-pagination" (pageChange)="page = $event"></pagination-controls>
             </div>
        </ng-container>   

        <ng-container  *ngIf="isComment" >

            <div class="card text-center">
                <div class="card-body">
                    <div class="row">                      
                        <div class="col-sm-4">   
                            <div class="text-center">
                        <table style="width:100%">
                            <tr>
                              <th>Prospect Name:</th>
                              <td>{{commentSectionData.clientName}}</td>
                            </tr>
                            <tr>
                              <th>Product Name:</th>
                              <td>{{commentSectionData.productName}}</td>
                            </tr>
                            <tr>
                              <th>Mobile:</th>
                              <td>{{commentSectionData.mobile}}</td>
                            </tr>
                             <tr>
                                <th>{{dynamicCommentTh}}:</th>
                                <td>{{dynamicCommentTd}}</td>
                              </tr>
                          </table>
                        </div> 
                        </div>

                        <div class="col-sm-4" style="background-color: #f0f5f5;">
                          <div class="row">
                             <div class="col-sm-12 text-center mt-2 previousComment">
                                Prospect Interactions.
                                 <hr>
                             </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12 text-center commentt">
                                <div class="com">
                                    <ol reversed>
                                        <li *ngFor="let comments of commentList;">
                                          <p>  <span class="comment_head"><b>Date: </b><span *ngIf="comments.date">{{comments.date.split("T")[0]}}</span></span>
                                            <!-- <span class="mx-4 comment_head"><b>Time: </b><span *ngIf="comments.date">{{comments.date.split("T")[1].split(".")[0]}}</span></span> -->
                                               <!-- <span class="mx-4 comment_head"><b>By: </b><span *ngIf="comment.commentByName">{{comment.commentByName.split(" ")[0]}}</span></span> -->
                                               <br>
                                               <span>
                                                <!-- <b>Comment:&nbsp;&nbsp;</b> -->
                                                {{comments.comment}}<span *ngIf="!comments.comment">No Comment available.</span>
                                               </span>
                                        </p>   
                                        </li>
                                    </ol>  
                                </div>
                               <hr>
                            </div>
                          </div>

                        </div>
                        <div class="col-sm-4 my-2">
                            <form  #commentForm="ngForm" (ngSubmit)="onCommentSubmit(commentForm)">
                            <div class="form-group">
                                <label for="FormControlTextarea">Add New Comment.
                                    <hr>
                                </label>
                                <div class="info"><b>Note:</b> Not more than 200 characters are allowed.</div>
                                <textarea class="form-control" required maxlength="200" name="setcomment"  ngModel #setcomment="ngModel"></textarea>
                              </div>
                              <div *ngIf="setcomment.errors && commentForm.submitted" class="error">
                                <div *ngIf="setcomment.errors.required && commentForm.submitted">
                                   <small>Comment required.</small> 
                                </div>
                                <div *ngIf="setcomment.errors.maxlength && commentForm.submitted">
                                    <small>Maximum length 200 characters. </small>
                                </div>
                            </div>
                              <button type="button" class="btn btn-sm mx-2" id="comment-reset" (click)="resetCommentForm(commentForm);">Reset</button>
                              <button type="button" class="btn btn-sm " id="comment-cancel" (click)="cancelCommentForm();">Cancel</button>
                              <button type="submit" class="btn btn-sm mx-2" id="comment-button">Submit</button> 
                            </form>
                        </div>      
                </div>
               </div>
              </div>
            </ng-container>

    </div>
</div>

<div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
</div>


<!-- //COMMENTING OUT OLD CODE WHICH WAS STATIC VIEW ONLY WITH HARD CODED DATA VALUES.... -->
<!-- <div class="agent-dashboard">
    <div class="tabs">
        <ul>
            <li (click)="getRmProspects();" [ngClass]="{'active': isProspect}">Prospect</li>
            <li (click)="getRmClients();" [ngClass]="{'active': isClient}">Client</li>
            <li (click)="getRmRenewals();" [ngClass]="{'active': isRenewals}">Renewals</li>
        </ul>
    </div>
    <div class="list">
        <ng-container *ngIf="isProspect">
            <table>
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let enquiry of prospectData.prospectList1">
                        <td>{{enquiry.company}}</td>
                        <td>Initial Enquiry</td>
                    </tr>
                    <tr *ngFor="let follow of prospectData.prospectList2">
                        <td>{{follow.company}}</td>
                        <td>Follow Up</td>
                    </tr>
                    <tr *ngFor="let data of prospectData.prospectList3">
                        <td>{{data.company}}</td>
                        <td>Data Received</td>
                    </tr>
                    <tr *ngFor="let quote of prospectData.prospectList4">
                        <td>{{quote.company}}</td>
                        <td>Quotes submitted</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="isClient">
            <table>
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Last Edit</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let client of clientData">
                        <td>{{client.company}}</td>
                        <td>{{client.date}}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

        <ng-container *ngIf="isRenewals">
            <table>
                <thead>
                    <tr>
                        <th>Client Name</th>
                        <th>Renewal Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let renewal of renewalData">
                        <td>{{renewal.company}}</td>
                        <td>{{renewal.end_date}}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </div>
</div> -->